export default __webpack_public_path__ + "static/media/background-login.fab81d88.webp";